import React from 'react';
import { MegaMenuColumnMobile } from './components/mobile/MegaMenuColumnMobile';
import { LanguageSelectorMobile } from './components/common/LanguageSelector';
import { isWebCrawler } from '@helpers/isWebCrawler';
import './MainNavigationMobileNew.scss';
import { MobileNavigationList } from './components/mobile/MobileNavigationList';
import { SignInLinkInformation, TopMenu } from '@layouts/Header/Header.types';
import { MegaMenuNavigationItem, MegaMenuSegment } from './MegaMenu.types';
import { SignInDropdown } from '@components/SignInDropdown';
import { CountrySelector } from '@layouts/CountrySelector';
import { productShopUrl } from '@helpers/consts';

interface MainNavigationMobileNewProps {
  topMenu: TopMenu;
  navigation: MegaMenuNavigationItem[];
  contact: {
    Text: string;
    Href: string;
  };
  showing: boolean;
  columns: {
    [key: string]: MegaMenuSegment;
  };
  i18n: Record<string, string>;
  signInInformation?: string;
  showHideSignIn?: boolean;
  links?: SignInLinkInformation[];
}

const MainNavigationMobileNew = ({
  topMenu,
  navigation,
  contact,
  showing,
  columns,
  i18n,
  showHideSignIn,
  signInInformation,
  links,
}: MainNavigationMobileNewProps) => {
  const pageIsCrawled = isWebCrawler();

  return pageIsCrawled || showing ? (
    <div className={`l-header-mobile-menu ${!showing ? 'hidden' : ''}`}>
      <ul
        id='mobile-megamenu'
        style={{
          height: window.innerHeight - 56 + 'px',
        }}
        className='l-header-mobile-menu-list move-from-left'
      >
        <MobileNavigationList navigation={navigation} contact={contact} />
        {topMenu.SectionLinks.map((link, index) => (
          <li
            key={index}
            onClick={() => {
              window.location.href = link.Href;
            }}
            className='l-header-mobile-menu-item top-menu'
            //Story 365068 - Added new attribute i.e referrerpolicy="unsafe-url" if link.Href contains shop.alfalaval.com
            {...(link.Href?.includes(productShopUrl) && { referrerPolicy: 'unsafe-url' })}
          >
            {link.Text}
          </li>
        ))}
        {topMenu?.Languages && (
          <li className='l-header-mobile-menu-item language top-menu-language'>
            <LanguageSelectorMobile languages={topMenu.Languages} />
          </li>
        )}
        {(links.length > 0 || signInInformation) && !showHideSignIn && (
          <li>
            <div className='l-sign-in-mobile-area-container'>
              <div className='l-sign-in-mobile-area-header'>
                <SignInDropdown signInInformation={signInInformation} links={links} />
              </div>
            </div>
          </li>
        )}
        <li>
          <CountrySelector />
        </li>
      </ul>
      {navigation?.map(
        (nav, index) =>
          !nav.NoSubCategory && (
            <MegaMenuColumnMobile
              key={index}
              nav={nav}
              columnData={columns[nav.ContainerLink]?.Columns}
              i18n={i18n}
            />
          )
      )}
    </div>
  ) : null;
};

export default MainNavigationMobileNew;
